var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:{
        'badge--empty': _vm.count === 0,
        'badge--double-digit': _vm.count > 10,
        'badge--warning': _vm.type === 'warning',
        'badge--discrete': _vm.type === 'discrete',
    }},[(_vm.count > 0)?[_vm._v(_vm._s(_vm.count))]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }